@import 'theme/theme';

.input {
    padding: @margin;
    font-size: inherit;
    font-family: inherit;
    outline: none;
    border-radius: @borderRadius;
    border: 1px solid @darkGrayColor;
    background: @lightColor;
}

.inputContainer {
    position: relative;
    color: @darkColor;
    display: grid;

    input {
        .input;
    }
    &.validationError input {
        border-color: @warningColor;
    }

    option {
        color: @darkColor;
    }
}

.validationErrorLabel {
    position: relative;
    left: @margin;
    color: @warningColor;
    font-size: @mediumRel;
    font-weight: bold;
}

.clear {
    position: absolute;
    right: @margin;
    top: 0;
    bottom: 0;
    margin: auto;
}

.select {
    &.mobileNative {
        select {
            display: none;
        }

        @media @smallScreen {
            .reactSelect {
                display: none;
            }
            select {
                display: initial;
            }
        }
    }
}
